// extracted by mini-css-extract-plugin
module.exports = {"root":"NRICSettingForm_root__2cP-q","inputField":"NRICSettingForm_inputField__3N9ib","readMore":"NRICSettingForm_readMore__qkwgl","learnMore":"NRICSettingForm_learnMore__12Gne"};